import {
  DATA_NOVA_MAP_SEARCH_FAILURE,
  DATA_NOVA_MAP_SEARCH_REQUEST,
  DATA_NOVA_MAP_SEARCH_SUCCESS,
} from '../actions/data-nova-map';

const initialState: DataNovaMapState = {
  results: [],
  loading: false,
  error: null,
};

//TODO
export default (
  state = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: Record<string, any>
): DataNovaMapState => {
  switch (action.type) {
    case DATA_NOVA_MAP_SEARCH_REQUEST:
      return {
        ...state,
        results: [],
        context: {},
        error: null,
        loading: true,
      };

    case DATA_NOVA_MAP_SEARCH_SUCCESS:
      return {
        ...state,
        results: action.payload,
        context: action.context,
        error: null,
        loading: false,
      };

    case DATA_NOVA_MAP_SEARCH_FAILURE:
      return {
        ...state,
        results: [],
        context: {},
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export type DataNovaMapState = {
  results: [];
  loading: boolean;
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: any;
};
